import { DataComboServicio } from "./combo";
import { Producto } from "./producto";
import { Servicio } from "./servicio";
import { Ticket } from "./ticket";
import { User } from "./user.model";

export class Evento {
  id!: number;
  title!: string | null;
  startsAt!: Date | null;;
  endsAt!: Date | null;
  allDay!: boolean;
  description!: string | null;
  clienteId!: number | null;
  tiendaId!: number | null;
  forCalendar!: boolean;
  isBloqueaHoras!: boolean;
  pagado!: boolean;
  notificado!: string | null;
  ticketId!: number | null;
  eventServicios!: EventServicio[] | null;
  eventProductos!: EventProducto[] | null;

  constructor(init?: Partial<Evento>) {
    Object.assign(this, init);
  }
}

export class EventResumenCliente {
  id!: number;
  dia!: string | null;
  horaDesde!: string | null;
  horaHasta!: string | null;
  nombresUsuarios!: string[] | null;
  idTicket!: number;
  esTkEditable!: boolean;

  constructor(init?: Partial<Ticket>) {
    Object.assign(this, init);
  }
}

export class EventServicio {
  id!: number;
  eventId!: number | null;
  servicio!: Servicio;
  servicioPrize!: number;
  cantidad!: number;
  eventServicioDetalles: EventServicioDetalle[];

  constructor(init?: Partial<EventServicio>) {
    Object.assign(this, init);
  }
}

export class EventServicioDetalle {
  id!: number;
  eventServicio!: EventServicio;
  orden!: number | null;
  userId!: number | null;
  financiado!: number | null;
  numPlazos!: number | null;
  precioPlazo!: number;

  constructor(init?: Partial<EventServicioDetalle>) {
    Object.assign(this, init);
  }
}

export class EventProducto {
  id: number;
  event!: Evento | null;
  cantidad: number;
  producto: Producto;
  productoPrize!: number;
  eventProductoDetalles: EventProductoDetalle[];
}

export class EventProductoDetalle {
  id!: number;
  eventProducto!: EventProducto;
  orden!: number | null;
  userId!: number | null;
  financiado!: number | null;
  numPlazos!: number | null;
  precioPlazo!: number;

  constructor(init?: Partial<EventServicioDetalle>) {
    Object.assign(this, init);
  }
}

export interface RegisterItemCantidad  {
  id: number;      // ID del servicio o producto
  cantidad: number;   // Cantidad seleccionada
}

export interface RegisterEvent {
  id: number;
  clienteId: number;
  tiendaId: number;
  description: string | null;
  isBloqueaHoras: boolean;
  startsAt: string; // formato ISO: 'yyyy-MM-ddTHH:mm:ss'
  endsAt: string;
  servicios: RegisterItemCantidad[];
  productos: RegisterItemCantidad[];
}

